import React, { useState, useEffect } from "react";
import { commerce } from "../lib/commerce";
import { useForm, FormProvider } from "react-hook-form";
function AdressForm({ checkoutToken, next }) {
  const methods = useForm();

  const [shippingcountries, setshippingcountries] = useState([]);
  const [shippingcountry, setshippingcountry] = useState("");
  const [shippingsubdivisions, setshippingsubdivisions] = useState([]);
  const [shippingsubdivision, setshippingsubdivision] = useState("");
  const [shippingoptions, setshippingoptions] = useState([]);
  const [shippingoption, setshippingoption] = useState("");

  async function fetchshippingcountries(checkoutTokenId) {
    const response = await commerce.services.localeListShippingCountries(
      checkoutTokenId
    );
    setshippingcountries(response.countries);
    setshippingcountry(Object.keys(response.countries)[0]);
  }
  async function fetchSubdivisions(countryCode) {
    const response = await commerce.services.localeListSubdivisions(
      countryCode
    );
    setshippingsubdivisions(response.subdivisions);
    setshippingsubdivision(Object.keys(response.subdivisions)[0]);
  }
  async function fetchShippingOptions(checkoutTokenId, country, region = null) {
    const options = await commerce.checkout.getShippingOptions(
      checkoutTokenId,
      { country, region }
    );
    setshippingoptions(options);
    setshippingoption(options[0].id);
  }
  const countries = Object.entries(shippingcountries).map(([code, nameC]) => ({
    id: code,
    label: nameC,
  }));
  const subdivisions = Object.entries(shippingsubdivisions).map(
    ([code, nameC]) => ({
      id: code,
      label: nameC,
    })
  );
  const optionsZ = shippingoptions.map((sO) => ({
    id: sO.id,
    label: `${sO.description} - (${sO.price.formatted_with_symbol})`,
  }));
  useEffect(() => {
    fetchshippingcountries(checkoutToken.id);
  }, []);

  useEffect(() => {
    if (shippingcountry) fetchSubdivisions(shippingcountry);
  }, [shippingcountry]);

  useEffect(() => {
    if (shippingsubdivision) {
      fetchShippingOptions(
        checkoutToken.id,
        shippingcountry,
        shippingsubdivision
      );
    }
  }, [shippingsubdivision]);

  const [dataa, setdata] = React.useState({
    firstName: "",
    lastName: "",
    address: "",
    email: "",
    city: "",
    tel: "",
    zip: "",
  });
  function handleChange(event) {
    const { name, value, type } = event.target;
    setdata((prevdata) => {
      return { ...prevdata, [name]: value };
    });
  }

  return (
    <div>
      <div className="mx-44 my-20 pb-14 rouned-md phonex2:mx-8 phone:mx-14 demitablet:mx-24">
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit((data) =>
              next({
                dataa,
                shippingcountry,
                shippingsubdivision,
                shippingoption,
              })
            )}
          >
            <div className="relative text-gray-800 z-0 mb-6 w-full group ">
              <input
                onChange={handleChange}
                value={dataa.firstName}
                type="text"
                name="firstName"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-primary-100 focus:outline-none focus:ring-0 focus:border-primary-100 peer"
                placeholder=" "
                required
              />
              <label
                htmlFor="firstName"
                className="absolute text-sm text-gray-900 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-100 peer-focus:dark:text-primary-100 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                First Name
              </label>
            </div>
            <div className="relative z-0 mb-6 w-full group">
              <input
                onChange={handleChange}
                value={dataa.lastName}
                type="text"
                name="lastName"
                id="floating_password"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-primary-100 focus:outline-none focus:ring-0 focus:border-primary-100 peer"
                placeholder=" "
                required
              />
              <label
                htmlFor="lastName"
                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-100 peer-focus:dark:text-primary-100 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Last Name
              </label>
            </div>
            <div className="relative z-0 mb-6 w-full group">
              <input
                onChange={handleChange}
                value={dataa.address}
                type="text"
                name="address"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-primary-100 focus:outline-none focus:ring-0 focus:border-primary-100 peer"
                placeholder=" "
                required
              />
              <label
                htmlFor="address"
                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-100 peer-focus:dark:text-primary-100 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Address
              </label>
            </div>
            <div className="grid xl:grid-cols-2 xl:gap-6">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  onChange={handleChange}
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  value={dataa.email}
                  type="email"
                  name="email"
                  className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-primary-100 focus:outline-none focus:ring-0 focus:border-primary-100 peer"
                  placeholder=" "
                  required
                />
                <label
                  htmlFor="email"
                  className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-100 peer-focus:dark:text-primary-100 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Email
                </label>
              </div>
              <div className="relative z-0 mb-6 w-full group">
                <input
                  onChange={handleChange}
                  value={dataa.city}
                  type="text"
                  name="city"
                  className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-primary-100 focus:outline-none focus:ring-0 focus:border-primary-100 peer"
                  placeholder=" "
                  required
                />
                <label
                  htmlFor="city"
                  className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-100 peer-focus:dark:text-primary-100 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  City
                </label>
              </div>
            </div>
            <div className="grid xl:grid-cols-2 xl:gap-6">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  onChange={handleChange}
                  value={dataa.tel}
                  type="tel"
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                  name="tel"
                  className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-primary-100 focus:outline-none focus:ring-0 focus:border-primary-100 peer"
                  placeholder=" "
                  required
                />
                <label
                  htmlFor="tel"
                  className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-100 peer-focus:dark:text-primary-100 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Phone number (123-456-7890)
                </label>
              </div>
              <div className="relative z-0 mb-6 w-full group">
                <input
                  onChange={handleChange}
                  value={dataa.zip}
                  type="text"
                  name="zip"
                  className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-primary-100 focus:outline-none focus:ring-0 focus:border-primary-100 peer"
                  placeholder=" "
                  required
                />
                <label
                  htmlFor="zip"
                  className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-100 peer-focus:dark:text-primary-100 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  ZIP / Postal Code
                </label>
              </div>
            </div>
            <div>
              <label
                htmlFor="countries"
                className="block mb-2 text-sm font-medium text-gray-500 dark:text-gray-400"
              >
                Shipping Country
              </label>
              <select
                value={shippingcountry}
                onChange={(e) => setshippingcountry(e.target.value)}
                id="countries"
                className="bg-gray-50 border mb-10 border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-primary-100 focus:border-primary-100 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-100 dark:focus:border-primary-100"
              >
                {countries.map((country, index) => (
                  <option key={index} value={country.id}>
                    {country.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label
                htmlFor="countries"
                className="block mb-2 text-sm font-medium text-gray-500 dark:text-gray-400"
              >
                Shipping Subdivision
              </label>
              <select
                value={shippingsubdivision}
                onChange={(e) => setshippingsubdivision(e.target.value)}
                id="countries"
                className="bg-gray-50 border mb-10 border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-primary-100 focus:border-primary-100 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-100 dark:focus:border-primary-100"
              >
                {subdivisions.map((subdivision, index) => (
                  <option key={index} value={subdivision.id}>
                    {subdivision.label}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label
                htmlFor="countries"
                className="block mb-2 text-sm font-medium text-gray-500 dark:text-gray-400"
              >
                Shipping Option
              </label>
              <select
                value={shippingoption}
                onChange={(e) => setshippingoption(e.target.value)}
                id="countries"
                className="bg-gray-50 border mb-10 border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-primary-100 focus:border-primary-100 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-100 dark:focus:border-primary-100"
              >
                {optionsZ.map((optiona, index) => (
                  <option key={index} value={optiona.id}>
                    {optiona.label}
                  </option>
                ))}
              </select>
            </div>
            <button
              type="submit"
              className="text-white w-full bg-primary-100 hover:bg-primary-100focus:ring-4 focus:outline-none focus:ring-primary-100 font-medium rounded-md text-sm   px-5 py-4 text-center dark:bg-primary-100 dark:hover:bg-primary-100 dark:focus:ring-primary-100"
            >
              Submit
            </button>
          </form>
        </FormProvider>
      </div>
    </div>
  );
}

export default AdressForm;
